import React, { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { Button, TextField, Typography, Box, CircularProgress, Divider, Link } from '@mui/material';
import { AuthContext } from '../../helper/context/auth/authContext';
import { useResponsive } from '../../helper/use-reponsive';
import { userLogin, verifyOtp } from '../../helper/api/api';
import { useNavigate } from 'react-router-dom';

const SendOTP = (props) => {
  const navigate = useNavigate();
  const { otpLogin } = useContext(AuthContext);
  const upLg = useResponsive('up', 'lg');
  const [step, setStep] = useState('email');
  const [isLoading, setIsLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [ipAddress, setIpAddress] = useState('');
  const [otpValue, setOtpValue] = useState('');

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ defaultValues: { Email: props?.email } });

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const onSubmit = async(data) => {
    const isMobileDevice = () => {
    const ua = navigator.userAgent.toLowerCase();
    const smallScreen = window.innerWidth < 768;
    const isMobileUA = /android|iphone|ipad|mobile|ipod/.test(ua);
      return isMobileUA || smallScreen;
    };
    if (isMobileDevice()) {
      toast.error("Mobile login is restricted.");
        return;
    }
    setIsLoading(true);
    const postData = { Email: data?.Email, Mobile: "", Password: "", IP: ipAddress, DeviceId: "", FCMToken: "", IsMobile: 0 };
    props?.setEmail(data?.Email);
    userLogin(postData)
      .then((response) => {
        if (response?.data?.data?.Status === "Failed") {
          toast.error(response?.data?.Message || response?.data?.message);
        } else {
          toast.success(response?.data?.data?.Message || response?.data?.data?.message);
          setCountdown(95);
          setStep('otp');
        }
      })
      .catch((error) => {
        toast.error(error?.data?.Message || error?.response?.data?.message);
      })
      .finally(() => setIsLoading(false));
  };

  const handleResendOTP = () => {
    setIsLoading(true);
    const postData = { Email: props?.email, Mobile: "", Password: "", IP: ipAddress };
    userLogin(postData)
      .then((response) => {
        if (response?.data?.data?.Status === "Failed") {
          toast.error(response?.data?.Message || response?.data?.message);
        } else {
          toast.success('OTP Resent Successfully!');
          setCountdown(95);
          setOtpValue('');
        }
      })
      .catch((error) => {
        toast.error(error?.data?.Message || error?.response?.data?.message);
      })
      .finally(() => setIsLoading(false));
  };

  const redirectToHome = () => {
    if (localStorage.getItem('token')) {
      const userData = JSON.parse(localStorage.getItem('userData'));
      if (userData[0]?.RoleName === 'Employee') {
        const Privilliages = JSON.parse(localStorage.getItem("Privilliages"));
        const filtered = Privilliages?.find((i) => i.ModuleName === 'HRMS Dashboard');
        navigate(filtered ? '/' : '/view-employee');
      } else {
        navigate('/');
      }
    }
  };

  const onSubmitOTP = async () => {
    if (otpValue.length !== 6) {
      toast.error("Please enter a valid 6-digit OTP");
      return;
    }

    setIsLoading(true);
    const postData = {
      Email: props?.email,
      Mobile: "",
      OTP: otpValue,
      ISLogin: 1,
      IP: ipAddress
    };

    try {
      const response = await verifyOtp(postData);
      const message = response?.data?.data?.Message;
      if (message?.includes("Invalid") || message?.includes("expired")) {
        toast.error(message);
      } else if (message) {
        toast.success(message);
        const success = await otpLogin(response?.data);
        if (success) {
          // Check for stored redirect URL after successful OTP login
          const redirectUrl = localStorage.getItem("redirectAfterLogin");
          if (redirectUrl) {
            localStorage.removeItem("redirectAfterLogin");
            window.location.href = redirectUrl;
          } else {
            window.location.reload();
            redirectToHome();
          }
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const renderFormContent = () => {
    switch (step) {
      case 'email':
        return (
          <form onSubmit={handleSubmit(onSubmit)}>
            <Typography variant="h5" gutterBottom>Email OTP Login</Typography>
            <Typography variant="body2">Enter your registered email address to receive the OTP.</Typography>
            <TextField
              label="Email"
              type="email"
              size='small'
              fullWidth
              margin="normal"
              value={props?.email || ''}
              {...register('Email', {
                required: 'Email is required',
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: 'Enter a valid email address',
                },
                onChange: (e) => props?.setEmail(e.target.value),
              })}
              error={!!errors.Email}
              helperText={errors.Email?.message}
            />
            <Box display='flex' pb={1} justifyContent='end'>
              <Link sx={{ cursor: 'pointer', fontSize: upLg ? "0.75rem" : "0.6rem" }} onClick={props.handleEmailPassword}>Back</Link>
            </Box>
            <Button variant="contained" type="submit" fullWidth disabled={isLoading} startIcon={isLoading && <CircularProgress size={20} />}>
              {isLoading ? 'Sending...' : 'Send OTP'}
            </Button>
          </form>
        );

      case 'otp':
        return (
          <form onSubmit={handleSubmit(onSubmitOTP)}>
            <Typography variant="h5" gutterBottom>Enter OTP</Typography>
            <Typography variant="body2" gutterBottom>
              OTP has been sent to: <strong>{props?.email}</strong>
            </Typography>
            <TextField
              label="Enter 6-digit OTP"
              value={otpValue}
              onChange={(e) => {
                const val = e.target.value.replace(/[^0-9]/g, '');
                if (val.length <= 6) setOtpValue(val);
              }}
              size="small"
              fullWidth
              margin="normal"
              inputProps={{ maxLength: 6 }}
            />
            <Box display='flex' pb={1} justifyContent='end'>
              <Link sx={{ cursor: 'pointer', fontSize: upLg ? "0.75rem" : "0.6rem" }} onClick={props.handleEmailPassword}>Back</Link>
            </Box>
            <Button variant="contained" type="submit" fullWidth disabled={isLoading} startIcon={isLoading && <CircularProgress size={20} />}>
              {isLoading ? 'Verifying...' : 'Verify OTP'}
            </Button>
            <Box display="flex" justifyContent="center" mt={2}>
              {countdown > 0 ? (
                <Typography variant="body2" color="textSecondary">
                  Resend OTP in {countdown} seconds
                </Typography>
              ) : (
                <Link color="primary" sx={{ cursor: 'pointer' }} onClick={handleResendOTP}>Resend OTP</Link>
              )}
            </Box>
          </form>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    const getLocalIP = () => {
      const pc = new RTCPeerConnection({ iceServers: [{ urls: 'stun:stun.l.google.com:19302' }] });
      pc.createDataChannel('');
      pc.createOffer().then((offer) => pc.setLocalDescription(offer));
      pc.onicecandidate = (event) => {
        if (event && event.candidate) {
          const candidate = event.candidate.candidate;
          const ipMatch = candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3})/);
          if (ipMatch) {
            setIpAddress(ipMatch[1]);
            pc.close();
          }
        }
      };
    };
    getLocalIP();
  }, []);

  return (
    <Box className='block pt-10 w-11/12 pb-10'>
      <Box className="form-card mb-5">{renderFormContent()}</Box>
      <Divider sx={{ "& span": { fontSize: upLg ? "0.75rem" : "0.6rem" } }}>OR</Divider>
      <Button onClick={props.handleEmailPassword} variant="contained" fullWidth sx={{ mt: 3, height: '30px', fontSize: '12px' }}>
        Login With Password
      </Button>
    </Box>
  );
};

export default SendOTP;
